import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import { AuthProvider, useAuth } from './AuthContext';
import Layout from './components/Layout';
import AdminLayout from './admin/components/AdminLayout';
import NewOrder from './pages/NewOrder';
import Orders from './pages/Orders';
import AddFund from './pages/AddFund';
import Services from './pages/Services';
import Tickets from './pages/Tickets';
import TopUsers from './pages/TopUsers';
import Profile from './pages/Profile';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminDashboard from './admin/pages/AdminDashboard';
import AdminServices from './admin/pages/AdminServices';
import AdminOrders from './admin/pages/AdminOrders';
import AdminTickets from './admin/pages/AdminTickets';
import AdminUsers from './admin/pages/AdminUsers';
import AdminProviders from './admin/pages/AdminProviders';
import AdminTopUsers from './admin/pages/AdminTopUsers';
import AdminOffers from './admin/pages/AdminOffers';
import AdminSettings from './admin/pages/AdminSettings';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="auth-loading">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="auth-loading">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function GuestRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="auth-loading">Loading...</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<GuestRoute><Login /></GuestRoute>} />
            <Route path="/register" element={<GuestRoute><Register /></GuestRoute>} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />

            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<NewOrder />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/add-fund" element={<AddFund />} />
              <Route path="/services" element={<Services />} />
              <Route path="/tickets" element={<Tickets />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/top-users" element={<TopUsers />} />
            </Route>

            <Route element={<AdminRoute><AdminLayout /></AdminRoute>}>
              <Route path="/beast" element={<AdminDashboard />} />
              <Route path="/beast/services" element={<AdminServices />} />
              <Route path="/beast/orders" element={<AdminOrders />} />
              <Route path="/beast/tickets" element={<AdminTickets />} />
            <Route path="/beast/users" element={<AdminUsers />} />
            <Route path="/beast/providers" element={<AdminProviders />} />
            <Route path="/beast/top-users" element={<AdminTopUsers />} />
            <Route path="/beast/offers" element={<AdminOffers />} />
            <Route path="/beast/settings" element={<AdminSettings />} />
          </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
